module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/e4KT1I/tc-custom/9781646569311.jpg?1693961627630",
      "alt": "This image is the cover for the book Southern Fried"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Southern Fried\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When orphaned Trip Jackson’s granny dies, leaving most of her extensive estate to him and a puzzling stranger, the mysteries start piling on from there. How did Trip’s parents really die? What’s the deal with the conservative senator who shares the stranger’s last name? What’s with all the blackmail? And does Billy Ray really have the hottest, saltiest boiled nuts this side of the Mason-Dixon? Only Trip and his hot stable boy-boyfriend Zeb know for sure, and how they come by the answers makes for one erotically charged and funny whodunit."), _c('br'), _c('br'), _c('i', [_vm._v("Southern Fried")]), _vm._v(", at its core, is about the love of family, the love of one’s heritage, and the love between friends, both old and new. Though not all is as it appears to be, and sometimes life can get turned upside down when you least expect it. Especially when lip-smacking romance, deep-fried humor, and a heaping side of mystery fall on your plate, all served up Southern style.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rob Rosen\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0